import PropTypes from 'prop-types';

import styles from './CalendarDateSlots.scss';

import { selectableItem } from '../../..';
import { CalendarDateSlot } from './calendar-date-slot';

const SelectableCalendarDateSlot = selectableItem(CalendarDateSlot);

export const CalendarDateSlots = ({ dates, selectedDateSlot, selectDateSlot }) => (
  <ul className={styles.Calendar__slots}>
    {dates.map((slot, index) => {
      const { date, times, day, dateNumber } = slot;

      const extraStyles = {};

      if (index === 0) {
        const dayOfWeek = day === 0 ? 6 : day - 1;
        const leftOffset = (100 / 7) * dayOfWeek;
        extraStyles.marginLeft = `${leftOffset}%`;
      }

      return (
        <li style={extraStyles} key={date}>
          <SelectableCalendarDateSlot
            slot={slot}
            day={dateNumber}
            propName="slot"
            isChecked={selectedDateSlot === date && times.length > 0}
            onChange={times.length ? selectDateSlot : undefined}
            isDisabled={!times.length}
          />
        </li>
      );
    })}
  </ul>
);

const slotShape = PropTypes.shape({
  date: PropTypes.string.isRequired,
  times: PropTypes.arrayOf(PropTypes.shape({})),
  day: PropTypes.number,
  dateNumber: PropTypes.number,
});

CalendarDateSlots.propTypes = {
  dates: PropTypes.arrayOf(slotShape.isRequired).isRequired,
  selectedDateSlot: PropTypes.string.isRequired,

  selectDateSlot: PropTypes.func.isRequired,
};
